import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { IconButton } from '@calendly/ui/components/icon-button'
import { CloseIcon } from '@calendly/ui/components/icons'
import { Modal } from '@calendly/ui/components/modal'
import { Body, Footer, Title } from '@calendly/ui/components/popup'
import { useDispatch, useSelector } from 'react-redux'

import { useEnforceUpgrade } from 'components/billing/useEnforceUpgrade'
import {
  batchResendInvitations,
  isLoadingSelector,
  selectedEntitiesCountSelector,
  setIsLoading
} from 'features/users_page'

import { Header, ModalContainer, ViewContainer } from '../styles'
import { PendingUsersList } from './pending_users_list'

export const PendingUsersModal = ({ isOpen, onClose }) => {
  const dispatch = useDispatch()
  const selectionCount = useSelector(selectedEntitiesCountSelector)
  const anySelectedEntities = selectionCount > 0
  const enforceUpgrade = useEnforceUpgrade('organization_invitation', { skipPreface: true })
  const isLoading = useSelector(isLoadingSelector)

  const handleResend = () => {
    enforceUpgrade(() => {
      dispatch(setIsLoading(true))
      dispatch(batchResendInvitations())
    })
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalContainer>
        <Header>
          <Title>{I18n.t('publisher.admin.dashboard.section.users.modal.pending_users.title')}</Title>
          <IconButton title={I18n.t('publisher.action.close')} onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Header>
        <Body>
          <ViewContainer>
            <PendingUsersList />
          </ViewContainer>
        </Body>
        <Footer>
          <Button
            onClick={onClose}
            decoration="secondary-outline"
          >
            {I18n.t('publisher.action.cancel')}
          </Button>
          <Button
            onClick={handleResend}
            disabled={!anySelectedEntities}
            loading={anySelectedEntities && isLoading}
          >
            {I18n.t('publisher.admin.dashboard.section.users.modal.pending_users.resend_invites')}
          </Button>
        </Footer>
      </ModalContainer>
    </Modal>
  )
}
